// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-typography{
  font-family: "Poppins" !important;
}

.product-card .ant-card-body {
  padding: 12px;
}
.recommendation-card{
    margin-top: 0px;
    padding: 0px 10px 0px 22px;
    background-color: white;
    border-radius: 10px;
}

.product-card .ant-card-cover {
  margin: 0 !important;   /* remove AntD default negative margins */
  padding: 0;
  border: none;
}
.product-card-title {
  font-size: 14px;
  display: -webkit-box !important;
    -webkit-line-clamp: 2;   /* number of lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;  /* ensures long words don’t overflow */
    white-space: normal;
}

.product-card-price {
  font-size: 14px!important;

}
.product-card-subtitle{
  font-size: 14px !important;
}

.product-card-price-unit{
  font-size: 14px!important;
  font-weight: 400;
  margin-left: 6px;
}
.productImage img{
  width: 16px!important;
  height:16px!important;
}

.product-card img {
  width: 100%;
  /* height: auto; */
  height: 80px;
  max-height: 80px; /* default for desktop */
  object-fit: contain;
}

.product-footer {
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content:center;
}

.store-logo {
  width: 20px !important;
  height: 20px !important;
  object-fit: contain;
  display: block;
}

.product-link-btn {
  border-radius: 4px !important;
  font-size: 12px;       /* smaller for mobile */
  font-weight: 500;
  padding: 0 10px;
  white-space: nowrap;   /* prevent text wrap */
  width:fit-content!important;

}

/* .product-link-btn {
  background-color: var(--btn-bg, #005cff) !important;
  border-color: var(--btn-bg, #005cff) !important;
  color: var(--btn-color, #fff) !important;
} */
.product-card-rating{
  font-size: 12px !important;
  width: 100%!important;
}
.product-card-rating-review{
      font-size: 12px !important;
      width: 56%!important;
  }

  .product-card .ant-rate {
      font-size: 12px !important;
      width: 86%!important;
    }
    .product-card .ant-rate-star {
        margin-right: 2px !important; /* tighter spacing */
      }

/* .product-link-button{
  min-width: 140px;
} */
.product-card-image-container{
  min-width: 180px;
}

.product-card-image-container-new{
  min-width: 180px;
}
.product-link-button{
  padding:0px 16px !important;
  height: 26px;
}
.product-link-button-sub-category{
  padding:10px !important;
  height: 26px;
}
.product-link-button-sub-category span{
  font-size: 14px !important;
}

.product-link-button span{
  font-size: 12px !important;
}


@media(max-width: 380px){
  .all-picks-product-card .product-card-image-container{
   min-width: 35px !important;
  }

  .all-picks-product-card .product-card-image-container-new{
    min-width: 35px !important;
   }
}
@media (max-width: 768px) {

  .product-card img {
      max-height: 120px; /* reduce height on tablets/mobile */
    }

  .product-card .ant-card-body {
    padding: 8px 8px 12px 8px !important;
  }

  .product-card-title {
    font-size: 14px !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;   /* number of lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;  /* ensures long words don’t overflow */
    white-space: normal;
  }

  .product-card-rating{
      font-size: 14px !important;
      width: 100%!important;
  }
  .product-card-rating-review{
      font-size: 10px !important;
      width: 56%!important;
  }

  .product-card-price {
    font-size: 12px !important;
    width:fit-content!important;
    margin-right:6px;
  }
  .product-card-price-unit{
      font-size: 8px!important;
      font-weight: 400;
      margin-left: 6px;
    }

  .product-card .ant-rate {
    font-size: 8px !important;
    width: 86%!important;
  }
  .product-card .ant-rate-star {
      margin-right: 2px !important; /* tighter spacing */
    }

  .product-card .ant-btn {
    font-size: 8px !important;
    padding: 0px 11px;
  }

  .store-logo {
      width: 18px !important;
      height: 18px !important;
      object-fit: contain;
      display: block;
    }
    .product-link-btn {
      font-size: 8px!important;
      padding: 0 11px!important;
    }
}

@media (max-width: 480px) {
  .product-card img {
    height: 70px;
    width: 70px;
    max-height: 70px; /* even smaller for small phones */
  }

  .product-link-btn {
      font-size: 8px!important;
      padding: 0 11px!important;
    }
    .store-logo {
      width: 16px !important;
      height: 16px !important;
    }

    .product-link-button{
      min-width: auto;
    }
    .product-card-image-container{
      min-width: 90px;
    }
    .product-card-image-container-new{
      min-width: 70px;
    }
    .recommendation-card{
      margin-top: 0px;
      padding: 0px 2px 0px 2px;
      background-color: white;
      border-radius: 10px;
  }
}
@media (max-width: 994px) {
  .recommendation-card{
    margin-top: 0px;
    padding: 0px 2px 0px 2px;
    background-color: white;
    border-radius: 10px;
}
}`, "",{"version":3,"sources":["webpack://./src/components/common/product-card.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;AACA;IACI,eAAe;IACf,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;EACE,oBAAoB,IAAI,yCAAyC;EACjE,UAAU;EACV,YAAY;AACd;AACA;EACE,eAAe;EACf,+BAA+B;IAC7B,qBAAqB,IAAI,oBAAoB;IAC7C,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB,GAAG,sCAAsC;IAC/D,mBAAmB;AACvB;;AAEA;EACE,yBAAyB;;AAE3B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB,EAAE,wBAAwB;EAC1C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe,QAAQ,uBAAuB;EAC9C,gBAAgB;EAChB,eAAe;EACf,mBAAmB,IAAI,sBAAsB;EAC7C,2BAA2B;;AAE7B;;AAEA;;;;GAIG;AACH;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;MACM,0BAA0B;MAC1B,oBAAoB;EACxB;;EAEA;MACI,0BAA0B;MAC1B,oBAAoB;IACtB;IACA;QACI,4BAA4B,EAAE,oBAAoB;MACpD;;AAEN;;GAEG;AACH;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE;GACC,0BAA0B;EAC3B;;EAEA;IACE,0BAA0B;GAC3B;AACH;AACA;;EAEE;MACI,iBAAiB,EAAE,oCAAoC;IACzD;;EAEF;IACE,oCAAoC;EACtC;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;IAC/B,qBAAqB,IAAI,oBAAoB;IAC7C,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB,GAAG,sCAAsC;IAC/D,mBAAmB;EACrB;;EAEA;MACI,0BAA0B;MAC1B,qBAAqB;EACzB;EACA;MACI,0BAA0B;MAC1B,oBAAoB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;MACI,wBAAwB;MACxB,gBAAgB;MAChB,gBAAgB;IAClB;;EAEF;IACE,yBAAyB;IACzB,oBAAoB;EACtB;EACA;MACI,4BAA4B,EAAE,oBAAoB;IACpD;;EAEF;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;MACI,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;MACnB,cAAc;IAChB;IACA;MACE,wBAAwB;MACxB,yBAAyB;IAC3B;AACJ;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB,EAAE,kCAAkC;EACtD;;EAEA;MACI,wBAAwB;MACxB,yBAAyB;IAC3B;IACA;MACE,sBAAsB;MACtB,uBAAuB;IACzB;;IAEA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;MACf,wBAAwB;MACxB,uBAAuB;MACvB,mBAAmB;EACvB;AACF;AACA;EACE;IACE,eAAe;IACf,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;AACvB;AACA","sourcesContent":[".ant-typography{\n  font-family: \"Poppins\" !important;\n}\n\n.product-card .ant-card-body {\n  padding: 12px;\n}\n.recommendation-card{\n    margin-top: 0px;\n    padding: 0px 10px 0px 22px;\n    background-color: white;\n    border-radius: 10px;\n}\n\n.product-card .ant-card-cover {\n  margin: 0 !important;   /* remove AntD default negative margins */\n  padding: 0;\n  border: none;\n}\n.product-card-title {\n  font-size: 14px;\n  display: -webkit-box !important;\n    -webkit-line-clamp: 2;   /* number of lines */\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    word-break: break-word;  /* ensures long words don’t overflow */\n    white-space: normal;\n}\n\n.product-card-price {\n  font-size: 14px!important;\n\n}\n.product-card-subtitle{\n  font-size: 14px !important;\n}\n\n.product-card-price-unit{\n  font-size: 14px!important;\n  font-weight: 400;\n  margin-left: 6px;\n}\n.productImage img{\n  width: 16px!important;\n  height:16px!important;\n}\n\n.product-card img {\n  width: 100%;\n  /* height: auto; */\n  height: 80px;\n  max-height: 80px; /* default for desktop */\n  object-fit: contain;\n}\n\n.product-footer {\n  margin-top: auto;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  justify-content:center;\n}\n\n.store-logo {\n  width: 20px !important;\n  height: 20px !important;\n  object-fit: contain;\n  display: block;\n}\n\n.product-link-btn {\n  border-radius: 4px !important;\n  font-size: 12px;       /* smaller for mobile */\n  font-weight: 500;\n  padding: 0 10px;\n  white-space: nowrap;   /* prevent text wrap */\n  width:fit-content!important;\n\n}\n\n/* .product-link-btn {\n  background-color: var(--btn-bg, #005cff) !important;\n  border-color: var(--btn-bg, #005cff) !important;\n  color: var(--btn-color, #fff) !important;\n} */\n.product-card-rating{\n  font-size: 12px !important;\n  width: 100%!important;\n}\n.product-card-rating-review{\n      font-size: 12px !important;\n      width: 56%!important;\n  }\n\n  .product-card .ant-rate {\n      font-size: 12px !important;\n      width: 86%!important;\n    }\n    .product-card .ant-rate-star {\n        margin-right: 2px !important; /* tighter spacing */\n      }\n\n/* .product-link-button{\n  min-width: 140px;\n} */\n.product-card-image-container{\n  min-width: 180px;\n}\n\n.product-card-image-container-new{\n  min-width: 180px;\n}\n.product-link-button{\n  padding:0px 16px !important;\n  height: 26px;\n}\n.product-link-button-sub-category{\n  padding:10px !important;\n  height: 26px;\n}\n.product-link-button-sub-category span{\n  font-size: 14px !important;\n}\n\n.product-link-button span{\n  font-size: 12px !important;\n}\n\n\n@media(max-width: 380px){\n  .all-picks-product-card .product-card-image-container{\n   min-width: 35px !important;\n  }\n\n  .all-picks-product-card .product-card-image-container-new{\n    min-width: 35px !important;\n   }\n}\n@media (max-width: 768px) {\n\n  .product-card img {\n      max-height: 120px; /* reduce height on tablets/mobile */\n    }\n\n  .product-card .ant-card-body {\n    padding: 8px 8px 12px 8px !important;\n  }\n\n  .product-card-title {\n    font-size: 14px !important;\n    display: -webkit-box !important;\n    -webkit-line-clamp: 2;   /* number of lines */\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    word-break: break-word;  /* ensures long words don’t overflow */\n    white-space: normal;\n  }\n\n  .product-card-rating{\n      font-size: 14px !important;\n      width: 100%!important;\n  }\n  .product-card-rating-review{\n      font-size: 10px !important;\n      width: 56%!important;\n  }\n\n  .product-card-price {\n    font-size: 12px !important;\n    width:fit-content!important;\n    margin-right:6px;\n  }\n  .product-card-price-unit{\n      font-size: 8px!important;\n      font-weight: 400;\n      margin-left: 6px;\n    }\n\n  .product-card .ant-rate {\n    font-size: 8px !important;\n    width: 86%!important;\n  }\n  .product-card .ant-rate-star {\n      margin-right: 2px !important; /* tighter spacing */\n    }\n\n  .product-card .ant-btn {\n    font-size: 8px !important;\n    padding: 0px 11px;\n  }\n\n  .store-logo {\n      width: 18px !important;\n      height: 18px !important;\n      object-fit: contain;\n      display: block;\n    }\n    .product-link-btn {\n      font-size: 8px!important;\n      padding: 0 11px!important;\n    }\n}\n\n@media (max-width: 480px) {\n  .product-card img {\n    height: 70px;\n    width: 70px;\n    max-height: 70px; /* even smaller for small phones */\n  }\n\n  .product-link-btn {\n      font-size: 8px!important;\n      padding: 0 11px!important;\n    }\n    .store-logo {\n      width: 16px !important;\n      height: 16px !important;\n    }\n\n    .product-link-button{\n      min-width: auto;\n    }\n    .product-card-image-container{\n      min-width: 90px;\n    }\n    .product-card-image-container-new{\n      min-width: 70px;\n    }\n    .recommendation-card{\n      margin-top: 0px;\n      padding: 0px 2px 0px 2px;\n      background-color: white;\n      border-radius: 10px;\n  }\n}\n@media (max-width: 994px) {\n  .recommendation-card{\n    margin-top: 0px;\n    padding: 0px 2px 0px 2px;\n    background-color: white;\n    border-radius: 10px;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
